import { memo, useContext } from 'react'
import styled from 'styled-components'
import store from 'storeContext'
import AstroLogo from 'assets/images/astro-horizontal.svg'
// TextBody removed in favor of Typography with sx
import { Box, Checkbox, Typography } from '@astro-ui/components'

const TUKAR_GULING_MAX_ROW = 5
const BAD_STOCK_ROW = 4

function TemplateSupplyOrderDeliveryNote() {
  const { state: statePrintArea } = useContext(store.PrintAreaContext)
  const { driverName, plateNumber, temperatureBefore, temperatureAfter, documentId, data } =
    statePrintArea.dataDeliveryNoteBulk

  const header = [
    {
      label: 'Nama Driver',
    },
    {
      label: 'KM Awal',
    },
    {
      label: 'Jam Tiba',
    },
    {
      label: 'Seal',
    },
    {
      label: 'Plat Mobil',
    },
    {
      label: 'Suhu Sebelum Loading',
    },
    {
      label: 'Jam Berangkat',
    },
    {
      label: 'Rit',
    },
    {
      label: 'Tanggal',
    },
    {
      label: 'Suhu Setelah Loading',
    },
    {
      label: 'Suhu Wayback',
    },
    {
      label: 'Rute',
    },
  ]

  const dataShippingCheck = [
    'Proses Loading Sudah Sesuai?',
    'Kebersihan Mobil Sudah Sesuai?',
    'Tidak Adanya Kerusakan Seperti Bolong/Lubang Dari Mobil?',
    'Tidak Ada Bau Aneh Dari Mobil?',
    'Tumpukan Barang Sudah Sesuai Dan Rata?',
    'Jaring Sudah Dipasang?',
    'Koli Barang Dalam Kondisi Baik?',
  ]

  const RenderHeaderColiInformation = () => {
    return (
      <TableContainer fullWidth>
        <Tr borderTop>
          <Td width="33.3%" borderRight>
            <Typography fontSize={10} fontWeight={800}>
              Jmlh
            </Typography>
          </Td>
          <Td width="33.3%" borderRight>
            <Typography fontSize={10} fontWeight={800}>
              TTD
            </Typography>
          </Td>
          <Td width="33.3%">
            <Typography fontSize={10} fontWeight={800}>
              Nama
            </Typography>
          </Td>
        </Tr>
      </TableContainer>
    )
  }
  const RenderEmptyColi = () => {
    return (
      <TableContainer fullWidth>
        <Tr>
          <Td width="33.3%" borderRight>
            &nbsp;
          </Td>
          <Td width="33.3%" borderRight>
            &nbsp;
          </Td>
          <Td width="33.3%">&nbsp;</Td>
        </Tr>
      </TableContainer>
    )
  }
  const renderUnderscore = () => (
    <>
      <Typography
        sx={{ marginLeft: '5px', marginRight: '10px', fontSize: '7px', color: '#000000' }}
      >
        :
      </Typography>
      <Typography sx={{ fontSize: '7px', color: '#000000' }}>_________</Typography>
    </>
  )

  const renderValue = (value) => {
    if (value || value === 0) {
      return (
        <>
          <Typography
            sx={{ marginLeft: '5px', marginRight: '10px', fontSize: '7px', color: '#000000' }}
          >
            :
          </Typography>
          <Typography sx={{ fontSize: 8, width: 89, color: '#000000' }}>{value}</Typography>
        </>
      )
    }

    return renderUnderscore()
  }

  const renderUnderscoreForKmField = () => (
    <>
      <Typography
        sx={{ marginLeft: '5px', marginRight: '10px', fontSize: '7px', color: '#000000' }}
      >
        :
      </Typography>
      <Typography sx={{ fontSize: '7px', color: '#000000' }}>____</Typography>
    </>
  )

  return (
    <Container>
      <LogoWrapper className="page-header">
        <div>
          <Logo src={AstroLogo} />
        </div>
        <DeliveryNoteText>Surat Jalan</DeliveryNoteText>
        <NoForm>
          No form
          {documentId && <div>{documentId}</div>}
        </NoForm>
      </LogoWrapper>
      <HeaderWrapper>
        {header.map((value, key) => {
          return (
            <HeaderLabelWrapper key={key}>
              <Label>
                <Typography
                  sx={{
                    textTransform: 'uppercase',
                    flexBasis: '50%',
                    marginLeft: '10px',
                    fontSize: '7px',
                    color: '#000000',
                  }}
                >
                  {value.label}
                </Typography>

                {value.label === 'KM Awal' && renderUnderscoreForKmField()}

                {value.label !== 'KM Awal' &&
                  value.label !== 'Nama Driver' &&
                  value.label !== 'Plat Mobil' &&
                  value.label !== 'Suhu Sebelum Loading' &&
                  value.label !== 'Suhu Setelah Loading' &&
                  renderUnderscore()}

                {value.label === 'Nama Driver' && renderValue(driverName)}
                {value.label === 'Plat Mobil' && renderValue(plateNumber)}
                {value.label === 'Suhu Sebelum Loading' && renderValue(temperatureBefore)}
                {value.label === 'Suhu Setelah Loading' && renderValue(temperatureAfter)}

                {value.label === 'KM Awal' && (
                  <>
                    <Typography
                      sx={{
                        marginLeft: '10px',
                        textTransform: 'uppercase',
                        flexBasis: '50%',
                        fontSize: '7px',
                        color: '#000000',
                      }}
                    >
                      KM Akhir
                    </Typography>
                    {renderUnderscoreForKmField()}
                  </>
                )}
              </Label>
            </HeaderLabelWrapper>
          )
        })}
      </HeaderWrapper>
      {data?.map((el, key) => {
        return (
          <TableContainer fullWidth key={key}>
            <Tr bordered>
              <Td colored borderRight paddingLeft="5px">
                <Typography fontSize={10} fontWeight={800}>
                  Hub: {el.destinationLocationName || '-'}
                </Typography>
              </Td>
              <Td colored borderRight paddingLeft="5px">
                <Typography fontSize={10} fontWeight={800}>
                  Jam Tiba:
                </Typography>
              </Td>
              <Td colored borderRight paddingLeft="5px">
                <Typography fontSize={10} fontWeight={800}>
                  Suhu Box Fleet:
                </Typography>
              </Td>
              <Td colored bordered spacedLeft paddingLeft="5px">
                <Typography fontSize={10} fontWeight={800}>
                  Nomor seal hub:
                </Typography>
              </Td>
            </Tr>
            <Tr height={'40px'}>
              <Td colored bordered centerText width="40%">
                <Typography fontSize={10} fontWeight={800}>
                  Nomor SO
                </Typography>

                <Typography fontSize={10} fontWeight={800}>
                  (Regular)
                </Typography>
              </Td>
              <Td colored centerText bordered width="20%">
                <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
                  Koli Dispatch
                </Typography>

                <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
                  (Diisi WH)
                </Typography>
                <RenderHeaderColiInformation />
              </Td>
              <Td colored centerText bordered width="20%">
                <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
                  Koli Dikirim
                </Typography>

                <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
                  (Diisi Driver)
                </Typography>
                <RenderHeaderColiInformation />
              </Td>
              <Td colored centerText bordered width="20%">
                <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
                  Koli Diterima
                </Typography>

                <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
                  (Diisi HUB)
                </Typography>
                <RenderHeaderColiInformation />
              </Td>
            </Tr>

            {el.supplyOrderData.map((value, keyChild) => {
              return (
                <Tr key={keyChild}>
                  <Td bordered paddingLeft="12px">
                    <Typography fontSize={10} fontWeight={800}>
                      {value.supplyOrderNumber}
                    </Typography>
                  </Td>
                  <Td bordered>
                    <TableContainer fullWidth>
                      <Tr>
                        <Td width="33.3%" centerText borderRight>
                          <Typography fontSize={10} fontWeight={800}>
                            {value.koliDispatched}
                          </Typography>
                        </Td>
                        <Td width="33.3%" borderRight>
                          &nbsp;
                        </Td>
                        <Td width="33.3%">&nbsp;</Td>
                      </Tr>
                    </TableContainer>
                  </Td>
                  <Td bordered>
                    <TableContainer fullWidth>
                      <Tr>
                        <Td width="33.3%" centerText borderRight>
                          <Typography fontSize={10} fontWeight={800}>
                            {value.koliSent}
                          </Typography>
                        </Td>
                        <Td width="33.3%" borderRight>
                          &nbsp;
                        </Td>
                        <Td width="33.3%">&nbsp;</Td>
                      </Tr>
                    </TableContainer>
                  </Td>
                  <Td bordered>
                    <RenderEmptyColi />
                  </Td>
                </Tr>
              )
            })}
          </TableContainer>
        )
      })}
      <TableContainer fullWidth>
        <Tr height={'40px'}>
          <Td colored bordered centerText width="40%">
            <Typography fontSize={10} fontWeight={800}>
              Nomor SO
            </Typography>

            <Typography fontSize={10} fontWeight={800}>
              (Bad Stock)
            </Typography>
          </Td>
          <Td colored centerText bordered width="20%">
            <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
              Koli Dispatch
            </Typography>

            <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
              (Diisi HUB)
            </Typography>
            <RenderHeaderColiInformation />
          </Td>
          <Td colored centerText bordered width="20%">
            <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
              Koli Dikirim
            </Typography>

            <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
              (Diisi Driver)
            </Typography>
            <RenderHeaderColiInformation />
          </Td>
          <Td colored centerText bordered width="20%">
            <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
              Koli Diterima
            </Typography>

            <Typography fontSize={10} fontWeight={800} lineHeight={1.5}>
              (Diisi WH)
            </Typography>
            <RenderHeaderColiInformation />
          </Td>
        </Tr>
        {Array.from({ length: BAD_STOCK_ROW }).map((_, i) => (
          <Tr key={`bad_stock_${i + 1}`}>
            <Td bordered />
            <Td bordered>
              <RenderEmptyColi />
            </Td>

            <Td bordered>
              <RenderEmptyColi />
            </Td>
            <Td bordered>
              <RenderEmptyColi />
            </Td>
          </Tr>
        ))}
      </TableContainer>

      <Typography fontSize={12} fontWeight="bold" mt="2">
        Tukar Guling Asset (Checking)
      </Typography>

      <TableContainer fullWidth style={{ marginTop: '2px' }}>
        <thead>
          <Tr>
            <Th rowSpan="2">
              <Typography fontSize={10} fontWeight={800}>
                Nama Hub
              </Typography>
            </Th>
            <Th rowSpan="2">
              <Typography fontSize={10} fontWeight={800}>
                Jenis Asset
              </Typography>
            </Th>
            <Th colSpan="2">
              <Typography fontSize={10} fontWeight={800}>
                WH
              </Typography>
            </Th>
            <Th colSpan="2">
              <Typography fontSize={10} fontWeight={800}>
                HUB
              </Typography>
            </Th>
            <Th rowSpan="2">
              <Typography fontSize={10} fontWeight={800}>
                Catatan
              </Typography>
            </Th>
          </Tr>
          <Tr>
            <Th>
              <Typography fontSize={10} fontWeight={800}>
                Jumlah Ditagihkan
              </Typography>
            </Th>
            <Th>
              <Typography fontSize={10} fontWeight={800}>
                TTD
              </Typography>
            </Th>
            <Th>
              <Typography fontSize={10} fontWeight={800}>
                Jumlah Diberikan
              </Typography>
            </Th>
            <Th>
              <Typography fontSize={10} fontWeight={800}>
                TTD
              </Typography>
            </Th>
          </Tr>
        </thead>

        {Array.from({ length: TUKAR_GULING_MAX_ROW }).map((_, i) => {
          if (i === 0)
            return (
              <Tr key={`tukar_guling_${i + 1}`}>
                <Td bordered height="16px" paddingLeft="5px">
                  <Typography fontSize={10} fontWeight={800}>
                    Contoh: BS9
                  </Typography>
                </Td>
                <Td bordered paddingLeft="5px">
                  <Typography fontSize={10} fontWeight={800}>
                    2008
                  </Typography>
                </Td>
                <Td bordered paddingLeft="5px">
                  <Typography fontSize={10} fontWeight={800}>
                    5
                  </Typography>
                </Td>
                <Td bordered />
                <Td bordered paddingLeft="5px">
                  <Typography fontSize={10} fontWeight={800}>
                    3
                  </Typography>
                </Td>
                <Td bordered paddingLeft="5px" />
                <Td bordered paddingLeft="5px">
                  <Typography fontSize={10} fontWeight={800}>
                    Fleet Overload
                  </Typography>
                </Td>
              </Tr>
            )
          return (
            <Tr key={`tukar_guling_${i + 1}`}>
              <Td bordered height="16px" />
              <Td bordered />
              <Td bordered />
              <Td bordered />
              <Td bordered />
              <Td bordered />
              <Td bordered />
            </Tr>
          )
        })}
      </TableContainer>

      <Typography fontSize={12} fontWeight="bold" mt="2">
        Disclaimer
      </Typography>
      <Typography fontSize={10} fontStyle="italic" lineHeight={1.25}>
        Bagian ini akan digunakan sebagai konfirmasi dari pihak-pihak yang terlibat dalam proses
        pengiriman dan dinyatakan sah atas ketidaksesuaian yang terjadi.
      </Typography>

      <TableContainer fullWidth style={{ marginTop: '2px' }}>
        <thead>
          <Tr>
            <Th>No</Th>
            <Th>Cek Pengiriman</Th>
            <Th>Ya</Th>
            <Th>Tidak</Th>
            <Th>Alasan</Th>
          </Tr>
          {dataShippingCheck.map((item, index) => (
            <Tr key={item}>
              <Td bordered centerText width="5%">
                <Typography variant="body3">{index + 1}</Typography>
              </Td>
              <Td bordered paddingLeft="5px" width="40%">
                <Typography variant="body3" lineHeight={0}>
                  {item}
                </Typography>
              </Td>
              <Td bordered centerText width="5%">
                <Checkbox checked={false} size="small" sx={{ py: '4px', px: '8px' }} />
              </Td>
              <Td bordered centerText width="5%">
                <Checkbox checked={false} size="small" sx={{ py: '4px', px: '8px' }} />
              </Td>
              <Td bordered centerText width="50%"></Td>
            </Tr>
          ))}
        </thead>
      </TableContainer>

      <Box mt={3} display="flex" width="100%" justifyContent="flex-end" className="dynamic-break">
        <WrapperReason>
          <Box display="flex">
            <Box width="50%">
              <Typography fontSize={12}>Dibuat Oleh :</Typography>
              <Box mt="50px">
                <Typography fontSize={12}>Nama :</Typography>
                <Typography fontSize={12}>Jabatan :</Typography>
              </Box>
            </Box>
            <Box width="50%">
              <Typography fontSize={12}>Diketahui Oleh :</Typography>
              <Box mt="50px">
                <Typography fontSize={12}>Nama :</Typography>
                <Typography fontSize={12}>Jabatan :</Typography>
              </Box>
            </Box>
          </Box>
        </WrapperReason>
      </Box>
    </Container>
  )
}

export default memo(TemplateSupplyOrderDeliveryNote)

const Container = styled.div``

const TableContainer = styled.table`
  ${({ fullWidth }) => fullWidth && ` width: 100%;`}
  width: ${(props) => (props.width ? `${props.width}` : '')};
  height: ${(props) => (props.height ? `${props.height}` : '')};
  border-collapse: collapse;
  font-size: 12px;
  font-weight: 700;
  font-family: Nunito Sans;
`

const Tr = styled.tr`
  font-size: 12px;
  height: ${(props) => (props.height ? `${props.height}` : '')};
  ${({ bordered }) => bordered && `border: 1px solid #BFC9D9`}
  ${({ borderTop }) => borderTop && `border-top: 1px solid #BFC9D9`}
`
const Td = styled.td`
  font-size: 12px;
  width: ${(props) => (props.width ? `${props.width}` : '')};
  padding-left: ${(props) => (props.paddingLeft ? `${props.paddingLeft}` : '0')};
  ${({ colored }) => colored && `background:#F3F4F5;`}
  ${({ centerText }) => centerText && `text-align: center;`}
  ${({ bordered }) => bordered && `border: 1px solid #BFC9D9`}
  ${({ borderLeft }) => borderLeft && `border-left: 1px solid #BFC9D9`}
  ${({ borderRight }) => borderRight && `border-right: 1px solid #BFC9D9`}
  ${({ borderBottom }) => borderBottom && `border-bottom: 1px solid #BFC9D9`}
  ${({ borderTop }) => borderTop && `border-top: 1px solid #BFC9D9`}
  ${({ spacedLeft }) => spacedLeft && `padding-left: 12px`}
`

const Th = styled.th`
  background: #f3f4f5;
  border: 1px solid #bfc9d9;
  padding: 5px;
  text-align: ${(props) => props.align || 'center'};
`

const HeaderWrapper = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto;
  padding: 10px;
  align-items: end;
`

const Logo = styled.img`
  width: 157.54px;
  height: 32px;
`
const DeliveryNoteText = styled.div`
  font-family: 'Montserrat';
  font-style: normal;
  font-weight: 900;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.5px;
`
const NoForm = styled.div`
  border: 1px solid #8d96aa;
  border-radius: 8px;
  width: 192px;
  height: 48px;
  font-weight: 700;
  font-size: 12px;
  padding: 8px;
`
const LogoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #8d96aa;
  box-sizing: border-box;
`
const Label = styled.div`
  margin-bottom: 4px;
  display: flex;
  align-items: flex-end;
`
const HeaderLabelWrapper = styled.div`
  position: relative;
`
const WrapperReason = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #bfc9d9;
  width: 50%;
  box-sizing: border-box;
  padding: 5px;
  margin-top: 10px;
`
